import React from "react";
import PropTypes from "prop-types";
import STRINGS from "Constants/Strings";
import AppConstants from "Constants/AppConstants";
import AuthBody from "../Common/AuthBody/AuthBody";
import Stepper from "../Common/Stepper/Stepper";
import PopupModal from "Components/Common/PopupModal/PopupModal";
import { commaFormatted } from "../../Utils/CommonUtilities";

class Repayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountNo: "",
      institutionNo: "",
      transitNo: "",
      accountType: "",
      comments: "",
      accountTypeButton: "",
      showOther: false,
    };
  }

  componentDidMount() {
    const { getDataFromServer } = this.props;

    getDataFromServer(AppConstants.APPLICATIONSTEP.REPAYMENT, (response) => {
      console.log(response);
      this.setFormData(response);
    });
  }

  setFormData = () => {};

  handleAcctSelection = (event) => {
    const { updateRepayment, repayment } = this.props;
    updateRepayment({
      ...repayment,
      selectedOtherAccount: event.target.value,
    });
  };

  handleComment = (event) => {
    const { updateRepayment, repayment } = this.props;
    updateRepayment({
      ...repayment,
      comment: event.target.value,
    });
  };

  handleSelectAccountType = (accountType, product) => {
    console.log(accountType, product);
    const {
      openInverite,
      repayment,
      updateRepayment,
      accountList,
    } = this.props;
    console.log("handleSelectAccountType", accountType, product);
    if (
      accountType === AppConstants.ACCOUNT_TYPE.OTHER &&
      (!accountList || accountList?.length === 0)
    ) {
      openInverite();
    } else {
      updateRepayment({
        ...repayment,
        ...product,
        accountType,
      });
    }
  };

  handleContinue = () => {
    const { handleContinue } = this.props;
    handleContinue();
  };

  handleBack = () => {
    const { handleBack } = this.props;
    handleBack(AppConstants.APPLICATIONSTEP.REPAYMENT);
  };

  render() {
    const { accountTypeButton } = this.state;
    const {
      showModal,
      modal,
      type,
      toggleModal,
      handlePopupModalBtnClick,
      steps,
      activeStepID,
      accountList,
      repayment,
      openInverite,
      productList,
      accountError,
    } = this.props;
    console.log(steps, activeStepID);

    const accountTypeList = ["Chequing", "Savings"];

    const accountListComponent = accountList.map((account, index) => (
      <option value={account.account} className="[ dropdown__option ]">
        {account.account_description} {account.account}
      </option>
    ));
    const productListComponent = productList.map((product, index) => (
      <button
        type="button"
        disabled={
          product.productCode === repayment.accountType &&
          product.basicDetails.acctNo === repayment.basicDetails.acctNo
            ? true
            : false
        }
        className="[ btn custom-radio-unselected ] [ logo ]"
        value="chequing"
        onClick={(event) =>
          this.handleSelectAccountType(product.productCode, product)
        }
      >
        <div className="[ row ]">
          <div className="[ col-12 ] [ account-amount ]">
            <span>$ {commaFormatted((product.balance / 100).toFixed(2))}</span>
          </div>
          <div className="[ col-12 ] [ account-label ]">
            <span>{product.productDescription}</span>
          </div>
          <div className="[ col-12 ] [ account-num ]">
            <span>**** {product.basicDetails.acctNo}</span>
          </div>
        </div>
      </button>
    ));
    const accountTypeButtonComponent = (
      <div className="[ mb-3 ]">
        <div className="[ row ]">
          <div className="[ col-xl-6 ] [ mb-3 ]">
            <div className="[ product-card-container ]">
              <div className="[ row ]">
                <div className="[ col-12 ] [ form-subtitle ]">
                  {STRINGS.REPAYMENT.LOCAL_ACCOUNTS_SUBTITLE}
                </div>
              </div>

              <div className="[ row ] [ custom-radios ]">
                <div className="[ col-12 ]">
                  <div className="[ product-list ] ">
                    {productListComponent}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="[ col-xl-6 ] [ mb-3 ]">
            <div className="[ product-card-container ]">
              <div className="[ row ]">
                <div className="[ col-12 ] [ form-subtitle ]">
                  {STRINGS.REPAYMENT.OTHER_ACCOUNTS}
                </div>
              </div>

              <div className="[ row ] [ custom-radios ]">
                <div className="[ col-12 ]">
                  <div className="[ product-list ] ">
                    <button
                      type="button"
                      disabled={
                        AppConstants.ACCOUNT_TYPE.OTHER ===
                        repayment.accountType
                          ? true
                          : false
                      }
                      className="[ btn custom-radio-unselected ]"
                      value="otherFi"
                      onClick={(event) =>
                        this.handleSelectAccountType(
                          AppConstants.ACCOUNT_TYPE.OTHER,
                          {}
                        )
                      }
                    >
                      <div className="[ row ]">
                        <div className="[ col-12 ]">
                          <span className="[ account-label ]">
                            {STRINGS.REPAYMENT.OTHER_FINANCIAL_ACCOUNTS}
                          </span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            accountError.length > 0 ? "[ error-msg ]" : "[ ]"
          }
        >
          {accountError && !repayment.accountType ? accountError[0] : ""}
        </div>
      </div>
    );

    const actionComponent = (
      <div className="[ loan-details-container ]">
        <Stepper steps={steps} active={activeStepID} />

        <div className="[ form-title ]">{STRINGS.REPAYMENT.TITLE}</div>

        <div className="[ form-container ]">
          <div className="[ form-subtitle ]">{STRINGS.REPAYMENT.SUBTITLE}</div>

          {accountTypeButtonComponent}

          {repayment?.accountType === AppConstants.ACCOUNT_TYPE.OTHER && (
            <div className="[ drawer-content-container ] [ mb-3 ]">
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <div className="[ form-label ]">
                      {accountList?.length > 0 && <>{accountList[0].bank}</>}
                    </div>
                    {accountList?.length === 0 && (
                      <>{STRINGS.LOAN_DETAILS.FORM.NO_ACCOUNTS}</>
                    )}
                    {accountList?.length > 0 && (
                      <select
                        value={
                          repayment.selectedOtherAccount
                            ? repayment.selectedOtherAccount
                            : ""
                        }
                        className="[ form-control ] [ select__dropdown ]"
                        onChange={this.handleAcctSelection}
                        disabled={
                          accountTypeButton === accountTypeList[0] ||
                          accountTypeButton === accountTypeList[1]
                            ? true
                            : false
                        }
                      >
                        <option
                          value=""
                          className="[ default ] [ dropdown__option ]"
                        >
                          {STRINGS.REPAYMENT.FORM.ACCOUNT_DEFAULT_SELECT}
                        </option>
                        {accountListComponent}
                      </select>
                    )}
                    <div className="[ error-msg ]" />
                  </div>
                </div>
              </div>

              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <div
                      className="[ float-right ]"
                      role="button"
                      onClick={openInverite}
                    >
                      {STRINGS.REPAYMENT.FORM.CHANGE_FIN}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="[ mb-3 ]">
            <div className="[ row ]">
              <div className="[ col-12 ]">
                <div className="[ form-label ] ">
                  {STRINGS.REPAYMENT.FORM.COMMENTS_DESCRIPTION}
                </div>
                <textarea
                  className="form-control"
                  placeholder="Comment"
                  value={repayment.comment}
                  onChange={this.handleComment}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="button"
                className="[ btn  submit-btn ] [ w-100 ]"
                onClick={this.handleContinue}
              >
                {STRINGS.COMMON.CONTINUEBTN}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
    return (
      <>
        {showModal && (
          <PopupModal
            type={type}
            title={modal.title}
            description={modal.description}
            toggleModal={toggleModal}
            showModal={showModal}
            popupBtnClick={
              type === AppConstants.MODALTYPE.SUCCESS
                ? () => handlePopupModalBtnClick()
                : () => {}
            }
            closeBtnClick={
              type === AppConstants.MODALTYPE.SUCCESS
                ? () => handlePopupModalBtnClick()
                : () => {}
            }
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
        <AuthBody
          actionComponent={actionComponent}
          memberCreation
          handleBack={this.handleBack}
        />
      </>
    );
  }
}

Repayment.propTypes = {
  getDataFromServer: PropTypes.func,
  handleContinue: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
};

Repayment.defaultProps = {
  getDataFromServer: () => {},
  handleContinue: () => {},
  steps: [],
  activeStepID: -1,
};

export default Repayment;
